/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ w: NonNullable<unknown>, h: NonNullable<unknown> }} Media_DimensionsInputs */

const vi_media_dimensions = /** @type {(inputs: Media_DimensionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.w}×${i?.h} px`)
};

/**

* @param {Media_DimensionsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_dimensions = /** @type {((inputs: Media_DimensionsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_DimensionsInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_dimensions(inputs)
});